import React from "react"
import { useTranslations } from "next-intl"
import styled from "styled-components"

import GlobalDialog from "~/components/modals/GlobalDialog"
import WinItButton from "~/components/WinItButton"

// Traffic Ticket (TVB) lookup. Parking search inputs that match these patterns
// are traffic tickets, not parking tickets — offer to redirect instead.
export const TRAFFIC_TICKET_LOOKUP_URL = "https://www.trafficviolations.info/traffic/lookup"

// Modern NYPD electronic TVB tickets (e.g. B24XXXXXXX) and older handwritten
// A-series TVB tickets (e.g. ABE1234567). [A-NP-Z] excludes the letter O.
export const TRAFFIC_TICKET_PATTERN = /^(B\d{2}[A-NP-Z0-9]{7}|A[A-NP-Z]{2}\d{7})$/

export const isTrafficTicketNumber = value =>
  typeof value === "string" && TRAFFIC_TICKET_PATTERN.test(value.trim().toUpperCase())

const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  padding: 0 16px 16px;
  text-align: center;
`

const Body = styled.p`
  margin: 0 0 8px;
  font-size: 16px;
  color: #292f34;
`

const TrafficTicketRedirectDialog = ({ open, onClose }) => {
  const translate = useTranslations("form.parking.trafficRedirect")
  const goToTrafficLookup = () => {
    if (typeof window !== "undefined") {
      window.location.href = TRAFFIC_TICKET_LOOKUP_URL
    }
  }
  return (
    <GlobalDialog
      open={open}
      onClose={onClose}
      titleContent={<span>{translate("title")}</span>}
      bodyContent={(
        <Row>
          <Body>{translate("body")}</Body>
          <WinItButton
            color="blue"
            height={50}
            width="100%"
            fontSize="1rem"
            onClick={goToTrafficLookup}
          >
            {translate("confirm")}
          </WinItButton>
          <WinItButton
            color="white"
            height={50}
            width="100%"
            fontSize="1rem"
            onClick={onClose}
          >
            {translate("cancel")}
          </WinItButton>
        </Row>
      )}
    />
  )
}

export default TrafficTicketRedirectDialog
